module.exports = __webpack_public_path__ + "img/ring_r_0_null_0.b44f3d5d.png";